import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { WebPay } from "./components/WebPay";
import { OneClick } from "./components/OneClick";
import { PayWithDiscount } from "./components/PayWithDiscount";
import { useMachine } from "@/_zustand/machine";
import { useCompanyFlow } from "@/hooks/useCompanyFlow";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const PayDetailPage = () => {
  let query = useQuery();
  const [platform, setPlatform] = useState("");
  const { addressMachine, nameEmpresa } = useMachine();
  const { companyHomePath } = useCompanyFlow();

  useEffect(() => {
    if (query.get("platform")) {
      setPlatform(query.get("platform"));
    }
  }, [query]);

  return (
    <section id="pago" className="container my-5" style={{ flexGrow: 1 }}>
      <div className="row border border-1 inter-regular text-black p-2 font14 mb-5 d-flex justify-content-between">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-start">
            <Link to={companyHomePath} className="text-decoration-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={28}
                height={16}
                fill="currentColor"
                className="bi bi-geo-alt-fill"
                viewBox="0 2 18 18"
              >
                <path d="M 12 2 A 1 1 0 0 0 11.289062 2.296875 L 1.203125 11.097656 A 0.5 0.5 0 0 0 1 11.5 A 0.5 0.5 0 0 0 1.5 12 L 4 12 L 4 20 C 4 20.552 4.448 21 5 21 L 9 21 C 9.552 21 10 20.552 10 20 L 10 14 L 14 14 L 14 20 C 14 20.552 14.448 21 15 21 L 19 21 C 19.552 21 20 20.552 20 20 L 20 12 L 22.5 12 A 0.5 0.5 0 0 0 23 11.5 A 0.5 0.5 0 0 0 22.796875 11.097656 L 12.716797 2.3027344 A 1 1 0 0 0 12.710938 2.296875 A 1 1 0 0 0 12 2 z"></path>
              </svg>{" "}
              &#187;
            </Link>{" "}
            <Link to={-2} className="text-decoration-none">
              {nameEmpresa ? <span>{nameEmpresa} &#187;</span> : <span> </span>}
            </Link>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-end">
            <i className="bi bi-geo-alt-fill"></i> {addressMachine}
          </div>
        </div>
      </div>
      {platform === "webpay" && <WebPay />}
      {platform === "oneclick" && <OneClick />}
      {platform === "paywithdiscount" && <PayWithDiscount />}
    </section>
  );
};
